export default __webpack_public_path__ + "static/media/menu.c9695030.svg";